import { httpErrorHandler } from '../../common/functions/helpers';
import { fetchAddresses } from './nomineeService';
export const NOMINEE_ACTIONS = {
  UPDATE_NOMINEE_DETAILS: 'NOMINEE_ACTIONS.UPDATE_NOMINEE_DETAILS',
  RESET: 'NOMINEE_ACTIONS.RESET',
};

export const updateNomineeDetails = (values) => ({
  type: NOMINEE_ACTIONS.UPDATE_NOMINEE_DETAILS,
  payload: values,
});

export const resetNomineeDetails = () => ({
  type: NOMINEE_ACTIONS.RESET,
});

export const getAddressesByPostcode = (params, responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response);
  };

  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const response = await fetchAddresses(params.postcode, params.buildingNumber);
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(httpErrorHandler(error));
  }
};
